let products = [
//   {
//       title:"TCL 139.7 cm (55 inch) 3Yrs Warranty QLED Ultra HD (4K) Smart TV, C725 55C725",
//       images:["https://www.reliancedigital.in/medias/TCL-55C725-LED-TV-493179298-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNzA4MDAxfGltYWdlL2pwZWd8aW1hZ2VzL2hkNC9oYzQvOTkwNzc2NzE4MTM0Mi5qcGd8ZTY4OGRkZmM2NzNmZjU5M2I2MTEyYjAxMWE5NmNiMzcwOTdlZTc5ZTI5MDYwMjZlYTFlMjMxYzNlNzFmZjg2NQ"],
//       brand:"TCL",
//       category:"Televisions",
//       price:40990,
//       mrp:116990,
//       discount:65,
//   },
  {
      title:"Samsung Wondertainment 80 cm (32 Inch) Smart HD Ready TV, UA32T4340BKXXL",
      images:["https://www.reliancedigital.in/medias/Samsung-UA32T4340BKXXL-Smart-Television-492403650-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxOTMxMDl8aW1hZ2UvanBlZ3xpbWFnZXMvaDIyL2hmMy85ODQyMjA0OTM0MTc0LmpwZ3w4MTM3ZTc5YjY1NzhiNTYyZDFiMmNhMDI3OWU3NzQxZWUzMmVmYWI5NmFiMDUxMmY2ZjAzNWQyZjBmZDI3YTkx"],
      brand:"Samsung",
      category:"Televisions",
      price:13490,
      mrp:22900,
      discount:41,
  },
  {
      title:"ONEPLUS 108 cm (43 inch) Full HD Smart LED TV, 43Y1",
      images:["https://www.reliancedigital.in/medias/ONEPLUS-43Y1-TV-491895011-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxODYzOTV8aW1hZ2UvanBlZ3xpbWFnZXMvaGFlL2gzOC85ODEwMDU4Mzc5Mjk0LmpwZ3wwYWE2Y2UzOTE3MzU3ODI0ZjJmZjhkZGVmZTVkNzc3ODlmNzIwMjQ3N2U0ZWViMzFmOGYxMmYxZWNiZGM2NGUx"],
      brand:"ONEPLUS",
      category:"Televisions",
      price:22999,
      mrp:29999,
      discount:23,
  },
  {
      title:"MI 32 HD Ready Smart LED TV, 4A Horizon, ELA4546IN",
      images:["https://www.reliancedigital.in/medias/Mi-4A-Horizon-Edition-Television-492166368-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNjk2MzB8aW1hZ2UvanBlZ3xpbWFnZXMvaDY5L2hkYS85NzkwODc0NTE3NTM0LmpwZ3wwYmMzMWVjZWU4M2FiOTljNmVmNTYzYjhlYjY1NGIyZTEwNzc0ZTI1M2Y3YTFhMTEyYmRlOGMyODYwMmUzYzU1"],
      brand:"MI",
      category:"Televisions",
      price:16499,
      mrp:19999,
      discount:18,
  },
  {
      title:"BPL 81.28 cm (32 inch) HD Ready Android Smart LED TV, 32H-A4301",
      images:["https://www.reliancedigital.in/medias/BPL-32-HD-Television-492166140-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wyMTQ2NDB8aW1hZ2UvanBlZ3xpbWFnZXMvaDkzL2hlMC85NzMwMjcxOTM2NTQyLmpwZ3wyOTcyMjc4ZWZlNjkwYjhmMjhlMTc2YjJiNWZiYzFjNDM5NjIyODRiZmE4NjFhNDQwOTQyZjI2MTc4NGYwMWIx"],
      brand:"BPL",
      category:"Televisions",
      price:11990,
      mrp:27000,
      discount:56,
  },
  {
      title:"Hisense 80 cm (32 inch) 2Yr Warranty HD Smart LED TV with One Touch Access, Built-in Google Assistant (32A4G)",
      images:["https://www.reliancedigital.in/medias/Hisense-32A4G-Smart-Television-492338740-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxODUzMzl8aW1hZ2UvanBlZ3xpbWFnZXMvaDEyL2hhYi85Nzc5NjYxNzY2Njg2LmpwZ3wzYWUzNGRjMzVmMjdmMmIxNGQ1MTVhMjYyZGE2MWNhOTViZDFmMGIyNmIyMDMzMzkxZjEwZjdmZGM1OGU5NGJh"],
      brand:"Hisense",
      category:"Televisions",
      price:13490,
      mrp:24990,
      discount:46,
  },
  {
      title:"LG 81.28 cm (32 inch) HD LED Smart TV, 32LM562BPTA",
      images:["https://www.reliancedigital.in/medias/LG-32LM562BPTA-Televisions-492338698-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3w0NjA2MzJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDNiL2g0ZS85NjA1NTQ2ODM1OTk4LmpwZ3xiMjhmYjM4N2YyNmU5ZmMzYTljN2RhMzBlMTA1NDIxZmIxNGI3Y2QwYTNjMGRlY2NlN2ZlOGQ0ODIxMTA4ODUy"],
      brand:"LG",
      category:"Televisions",
      price:15990,
      mrp:20990,
      discount:24,
  },
  {
      title:"ONEPLUS 81.28 cm (32 inch) HD Smart LED TV, 32Y1",
      images:["https://www.reliancedigital.in/medias/ONEPLUS-32Y1-TV-491895010-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNjEzMzZ8aW1hZ2UvanBlZ3xpbWFnZXMvaGI4L2gyZC85ODEwMDU4NzA2OTc0LmpwZ3w2Yzg5YmJmZWM4NTdhYmY1MDA0OWRkYTFlZTA0ZWM1MzNkYjA4NzNmZDliZWFkYzg2ZWIyZmE5MmE4YjBjNzc3"],
      brand:"ONEPLUS",
      category:"Televisions",
      price:12499,
      mrp:19999,
      discount:38,
  }
];

export default products;